import { Component, registerComponent } from 'js/component.js';

const componentName = 'plex-global-nav';

const mobileBreakpoint = 1024;
const tabletBreakpoint = 1280;

const tabletCenterDropdownMargin = 40;
const desktopCenterDropdownMargin = 185;

let searchResultPage = 'https://rockwellautomation.com/en-us/search.html';

class GlobalNav extends Component {

    setup() {
        // ==========
        // Component Setup
        // ==========
        this.element = document.querySelector(`.${componentName}`);

        // Elements
        this.elements = {
            // Page
            body: document.body,
            header: document.querySelector('header.plex-global-nav'),
            nav: this.element.querySelector(`.${componentName}__nav`),
            overlay: this.element.querySelector(`.${componentName}__grey-overlay`),
            // Utility Header
            utilityHeader: this.element.querySelector(`.${componentName}__utility-header`),
            raQuickLinks: this.element.querySelector('ra-quick-links'),
            quicklinksWrapper: this.element.querySelector(`.${componentName}__quicklinks-wrapper`),
            quicklinksButton: this.element.querySelector(`.${componentName}__quicklinks-button`),
            quicklinksMenu: this.element.querySelector(`.${componentName}__quicklinks-menu`),
            // Main Header
            mainHeader: this.element.querySelector(`.${componentName}__main-header`),
            // Dropdown
            dropdownBackButton: this.element.querySelector(`.${componentName}__dropdown-back-button`),
            centerDropdownContainer: this.element.querySelector(`.${componentName}__center-dropdown-container`),
            dropdownLinks: this.element.querySelectorAll(`.${componentName}__dropdown-link`),
            dropdownOuterContainers: this.element.querySelectorAll(`.${componentName}__dropdown-outer-container`),
            // Search
            searchInput: this.element.querySelector(`.${componentName}__search-input`),
            searchSubmit: this.element.querySelector(`.${componentName}__search-submit`),
            centerSearchOuterContainer: this.element.querySelector(`.${componentName}__center-search-outer-container`),
            // Icon Buttons
            searchToggleButton: this.element.querySelector(`#${componentName}__search-toggle-button`),
            searchToggleButtonCloseIcon: this.element.querySelector(`.${componentName}__search-toggle-button-close-icon`),
            searchToggleButtonSearchIcon: this.element.querySelector(`.${componentName}__search-toggle-button-search-icon`),
            mobileMenuButton: this.element.querySelector(`.${componentName}__mobile-menu-button`),
            mobileMenuButtonIcons: this.element.querySelectorAll(`.${componentName}__mobile-menu-button span`),
            // Mobile
            utilityLinks: this.element.querySelector(`.${componentName}__utility-links`),
            supportButtonsContainerMobile: this.element.querySelector(`.${componentName}__support-buttons-container-mobile`),
            utilityHeaderLogoContainerMobile: this.element.querySelector(`.${componentName}__utility-header-logo-container-mobile`),
            mobileMenuIcon: this.element.querySelector(`.${componentName}__mobile-menu-icon svg`),
            mobileCloseMenuIcon: this.element.querySelector(`.${componentName}__mobile-close-icon svg`),
        };

        // Classes
        this.classes = {
            active: `${componentName}--active`,
            searchActive: `${componentName}--search-active`,
            mobileActive: `${componentName}--mobile-active`,
            dropdownActive: `${componentName}--dropdown-active`,
        };

        searchResultPage = this.elements.searchInput.getAttribute('data-search-result-page') || searchResultPage;

        this.headerHeight = this.elements.mainHeader.clientHeight;

        // Setup for Mobile
        const raQuickLinksMobile = this.elements.raQuickLinks.cloneNode(true);
        this.elements.utilityLinks.append(raQuickLinksMobile);
        this.elements.mobileMenuIcon.setAttribute('viewBox', '7 7 18 18');
        this.elements.mobileCloseMenuIcon.setAttribute('viewBox', '4 4 24 24');

        // Adjusting Dropdown Container Position if Header is Pushed Down
        setTimeout(() => {
            this.repositionDropdownContainer();
        }, 5000);
    }

    // ==========
    // Quicklinks Menu
    // ==========
    openQuicklinksMenu = () => {
        this.elements.quicklinksMenu.classList.add(this.classes.active);
        this.elements.quicklinksButton.classList.add(this.classes.active);
        this.repositionDropdownContainer();
    };

    closeQuicklinksMenu = () => {
        this.elements.quicklinksMenu.classList.remove(this.classes.active);
        this.elements.quicklinksButton.classList.remove(this.classes.active);
        if (document.activeElement === this.elements.quicklinksButton) {
            this.elements.quicklinksButton.blur();
        }
    };

    handleQuicklinksButton = () => {
        this.closeDropdowns();
        this.closeMobileMenu();

        if (this.elements.quicklinksButton.classList.contains(this.classes.active)) {
            this.closeQuicklinksMenu();
        } else {
            this.openQuicklinksMenu();
        }
    };

    // ==========
    // Search
    // ==========
    openSearch = () => {
        this.elements.searchInput.tabIndex = 0;
        this.elements.searchSubmit.tabIndex = 0;
        this.element.classList.add(this.classes.searchActive);
        this.elements.searchToggleButton.classList.add(this.classes.active);
    };

    closeSearch = () => {
        this.elements.searchInput.tabIndex = -1;
        this.elements.searchSubmit.tabIndex = -1;
        this.element.classList.remove(this.classes.searchActive);
        this.elements.searchToggleButton.classList.remove(this.classes.active);
    };

    handleSearchButton = () => {
        this.closeDropdowns();
        this.closeMobileMenu();

        if (this.element.classList.contains(this.classes.searchActive)) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
    };

    submitSearch = (searchTerm = null) => {
        if (typeof searchTerm !== 'string') {
            const cleanSearchTerm = this.elements.searchInput.value.replace('#', '%23');
            // eslint-disable-next-line no-param-reassign
            searchTerm = cleanSearchTerm.trim();
        }
        if (searchTerm === '') {
            return;
        }
        window.location.href = `${searchResultPage}?query_string=${searchTerm}`;
    };

    // ==========
    // Dropdown Menus
    // ==========
    openDropdown = (el) => {
        this.element.classList.add(this.classes.dropdownActive);
        el.classList.add(this.classes.active);
        el.nextElementSibling.classList.add(this.classes.active);
        document.body.style.overflowY = 'hidden';

        // Close Mobile Support Buttons
        this.elements.supportButtonsContainerMobile.classList.add('inactive');
        this.elements.utilityHeaderLogoContainerMobile.classList.add('inactive');

        this.elements.overlay.classList.add(this.classes.active);
    };

    closeDropdowns = () => {
        this.element.classList.remove(this.classes.dropdownActive);
        this.elements.dropdownLinks.forEach((el) => {
            el.classList.remove(this.classes.active);
            el.blur();
        });
        this.elements.dropdownOuterContainers.forEach((el) => {
            el.classList.remove(this.classes.active);
        });
        document.body.style.overflowY = null;
        this.elements.overlay.classList.remove(this.classes.active);
    };

    handleDropdownLink = (ev) => {
        ev.preventDefault();
        this.closeSearch();

        const el = ev.currentTarget;
        if (el.classList.contains(this.classes.active)) {
            this.closeDropdowns();
        } else {
            this.closeDropdowns();
            this.openDropdown(el);
        }
    };

    // ==========
    // Menu Close
    // ==========
    closeOnClickaway = (ev) => {
        // Quicklinks Menu
        if (!this.elements.quicklinksWrapper?.contains(ev.target)) {
            this.closeQuicklinksMenu();
        }
        // eslint-disable-next-line no-restricted-globals
        if (!this.elements.mainHeader?.contains(ev.target) || (window.innerWidth >= mobileBreakpoint && window.innerWidth < tabletBreakpoint && (ev.pageX < tabletCenterDropdownMargin || ev.pageX > window.innerWidth - tabletCenterDropdownMargin)) || (window.innerWidth >= tabletBreakpoint && (ev.pageX < desktopCenterDropdownMargin || ev.pageX > window.innerWidth - desktopCenterDropdownMargin))) {
            this.closeDropdowns();
        }
        if (this.elements.header.classList.contains(`${componentName}--search-active`) && !this.elements.centerSearchOuterContainer?.contains(ev.target) && !this.elements.searchToggleButton?.contains(ev.target)) {
            this.closeSearch();
        }
        if (window.innerWidth < mobileBreakpoint && !this.elements.mainHeader?.contains(ev.target)) {
            this.closeMobileMenu();
        }
    };

    // ==========
    // Mobile
    // ==========
    openMobileMenu = () => {
        this.element.classList.add(this.classes.mobileActive);
        this.elements.supportButtonsContainerMobile.classList.remove('inactive');
        this.elements.utilityHeaderLogoContainerMobile.classList.remove('inactive');
        this.elements.overlay.classList.add(this.classes.active);
    };

    closeMobileMenu = () => {
        this.element.classList.remove(this.classes.mobileActive);
        this.elements.overlay.classList.remove(this.classes.active);
    };

    handleMobileMenuButton = () => {
        this.repositionDropdownContainer();
        // Mobile menu button transforms into search close button when search is open
        if (this.element.classList.contains(this.classes.searchActive)) {
            this.closeSearch();
            return;
        }

        // Otherwise toggles mobile menu
        if (this.element.classList.contains(this.classes.mobileActive)) {
            this.closeMobileMenu();
        } else {
            this.openMobileMenu();
        }
    };

    handleDropdownBackButton = () => {
        this.closeDropdowns();

        // Open Mobile Support Buttons
        this.elements.supportButtonsContainerMobile.classList.remove('inactive');
        this.elements.utilityHeaderLogoContainerMobile.classList.remove('inactive');
        this.elements.overlay.classList.add(this.classes.active);
    };

    repositionDropdownContainer = () => {
        // eslint-disable-next-line no-restricted-globals
        if(window.innerWidth < mobileBreakpoint) {
            const rect = this.elements.mainHeader.getBoundingClientRect();
            this.elements.centerDropdownContainer.style.top = `${rect.bottom}px`;
            this.elements.quicklinksMenu.style.top = `${rect.bottom}px`;
        }
    };

    // ==========
    // Editable Initial Editing
    // ==========
    editableInitialEditing = () => {
        if(!window.location.href.includes('config-pages/header-config.html') && (document.querySelector('[data-path*="config-pages/header-config"]') !== null)) {
            document.querySelectorAll('[data-path*="config-pages/header-config"]').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll('[data-emptytext="Global Nav"]').forEach((el) => {
                el.remove();
            });
            document.querySelectorAll(`.${componentName}-editor-spacer`).forEach((el) => {
                el.remove();
            });
            document.querySelectorAll(`.${componentName}__quicklinks-menu`).forEach((el) => {
                el.remove();
            });
        }
    };

    // ==========
    // Event Listeners
    // ==========
    addEventListeners = () => {
        // Quicklinks
        this.elements.quicklinksButton.addEventListener('click', this.handleQuicklinksButton);
        // Search
        this.elements.searchToggleButton.addEventListener('click', this.handleSearchButton);
        this.elements.searchSubmit.addEventListener('click', this.submitSearch);
        this.elements.searchInput.addEventListener('keyup', (ev) => {
            if (ev.key === 'Enter') {
                this.submitSearch();
            }
        });
        // Dropdown
        this.elements.dropdownLinks.forEach((el) => el.addEventListener('click', this.handleDropdownLink));
        this.elements.dropdownLinks.forEach((el) => el.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter') {
                this.handleDropdownLink(ev);
            }
        }));
        this.elements.dropdownBackButton.addEventListener('click', this.handleDropdownBackButton);
        // Mobile Menu Button
        this.elements.mobileMenuButton.addEventListener('click', this.handleMobileMenuButton);
        // Clickaway
        document.addEventListener('click', this.closeOnClickaway);
        // Move Dropdown Component If Header Is Pushed Down
        document.addEventListener('scroll', this.repositionDropdownContainer);
        window.onresize = () => {
            this.repositionDropdownContainer();
        };
    };

    init() {
        this.setup();
        this.editableInitialEditing();
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, GlobalNav);